import React from "react";
import {Card, H2, Icon, RadioGroupField, theme} from "@reside/ui";

import {InfoNote, SectionBlock, SectionInstruction} from "./styles";
import {
  SSO_MANAGEMENT_FORM_FIELDS,
  SSO_USERS_OPTIONS,
} from "./constants";

type Props = Readonly<{
  onUsersChange: (event: React.FormEvent<HTMLInputElement>) => void;
}>;

export const SSOUsersCard = ({onUsersChange}: Props): JSX.Element => (
  <Card style={{padding: theme.space[7]}}>
    <SectionBlock>
      <H2>Set users that will sign in with SSO</H2>
      <SectionInstruction>
        Choose who will be required to sign into Reside with SSO authentication
      </SectionInstruction>
      <InfoNote>
        <Icon
          name="info"
          size={theme.fontSize[2]}
          style={{flexShrink: 0}}
        />
        <span>
          IT Admin users will only have access via email and password
        </span>
      </InfoNote>
      <RadioGroupField
        name={SSO_MANAGEMENT_FORM_FIELDS.SSO_USERS}
        options={SSO_USERS_OPTIONS}
        onChange={onUsersChange}
      />
    </SectionBlock>
  </Card>
);
